import dayjs from 'dayjs';

// 超过打赏截止时间没
// 一般是 complete 之前 12 小时
export const isTipOvertime = (deadline: number) => {
  return Date.now() > deadline * 1000;
};

// feed 打赏池是否已经完成？
// + 2d 的 23:59:59
// https://debankglobal.larksuite.com/wiki/Dc8xwNUHgivRTDkhy8QufL90sse
export const isTipComplete = (createAt: number) => {
  return dayjs
    .unix(createAt)
    .utc()
    .add(2, 'day')
    .set('hour', 23)
    .set('minute', 59)
    .set('second', 59)
    .isBefore(Date.now());
};
